import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "helpText" }

import {toRef} from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'GenericTextPopup',
  props: {
  data: Object
},
  setup(__props) {

const props = __props
const popupData = toRef(props, 'data');

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString(popupData.value.textToShow), 1))
}
}

})